import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M1 12.499s8.33 3.43 19.6 0c0-.045 0 0 0 0-2.406 0-6.549.49-13.408-4.499L1 12.499Zm20-.357h-.445c-.98.045-2.317.09-3.831-.133-.847-.134-1.693-.312-2.495-.58a7.046 7.046 0 0 1-.89-.311l2.94-2.094L21 12.143Z" />
  </svg>
);
